/* index.js */

"use strict";
module.exports.steveAddons = {
    control: require("./src/addons/ControlJnibAdapterAddOn"),
    lab: require("./src/addons/LabJnibAdapterAddOn"),
};
